import { useEffect } from "react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit, getSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { 
    filtersValue,
    tableFiltersValue, 
    isLoadingFilters, 
    isLoadingTable, 
    isLoadingStats,
    tableData, 
    totalCount,
    isTruncated,
    rowLimit,
    totalRows,
    statsData
} from "../@signals"


export default function useProductsReview() {
    const { showToast } = useAppToast()

    const fetchProducts = () => {
        isLoadingTable.value = true
        tableData.value = []
        
        postSubmit(`${BACKEND_APIS.PRODUCTS_REVIEW}/search`, tableFiltersValue.value)
            .then(res => {
                if (res) {
                    tableData.value = res.data || []
                    totalCount.value = res.total || 0
                    isTruncated.value = !!res.truncated
                    rowLimit.value = res.row_limit || 0
                    totalRows.value = res.total_rows || 0
                }
            })
            .catch(() => showToast.error('Error loading products'))
            .finally(() => {
                isLoadingTable.value = false
                isLoadingFilters.value = false
            })
    }

    const fetchStats = () => {
        isLoadingStats.value = true
        
        postSubmit(`${BACKEND_APIS.PRODUCTS_REVIEW}/stats`, filtersValue.value)
            .then(res => {
                if (res) {
                    statsData.value = res
                }
            })
            .catch(() => console.error('Error loading stats'))
            .finally(() => {
                isLoadingStats.value = false
            })
    }

    // Trigger search when filters are submitted
    useEffect(() => {
        if (isLoadingFilters.value) {
            fetchProducts()
            fetchStats()
        }
    }, [isLoadingFilters.value])

    return {
        isLoading: isLoadingTable.value,
        data: tableData.value,
        total: totalCount.value,
        refetch: fetchProducts
    }
}
